module.exports = __webpack_public_path__ + "img/22-about.b89503a9.jpg";